export const venderDetails = {
    name:'Mestertaket',
    colorGroup : {
        primary:'#EB7920',
        secondary:'#3D444E',
        textColor:'#000'
    }
}